import md5 from 'crypto-js/md5';
export const gen_security_key = (arr) => {
    /* $arr[] = date('Y-m-d');
  return md5(implode('-',$arr));*/
  
    return md5(arr.join('-'));
}